import { Navigate } from 'react-router'

import { useAuth } from '@/shared/contexts/AuthContext'
import { ui } from '@/shared/strings/ui'

export function RootRedirect(): React.ReactElement {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">{ui.common.loading}</div>
      </div>
    )
  }

  if (user?.type === 'admin') return <Navigate to="/admin" replace />
  if (user?.type === 'judge') return <Navigate to="/competition" replace />

  // No session — show nothing useful. Admins know to go to /login.
  // Judges arrive via magic links. No redirect needed.
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground">{ui.common.loading}</div>
    </div>
  )
}
